import script from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndConditions.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=7e29ce30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e29ce30"]])

export default __exports__